export const isLoading = (state) => state.auth.loading;
export const isError = (state) => state.auth.error;
export const isAuthenticated = (state) => state.auth.isAuthenticated;
export const Token = (state) => state?.otpVerificationReducer?.Authtoken;
export const getUserData = (state) => state?.AuthReducer?.userData
export const ProfileImage = (state) => state?.ProfileReducer?.getuserData?.profile_pic
export const ConfigData = (state) => state?.ConfigdataReducer?.configData
export const gettingDailyReward = (state) => state?.AuthReducer?.userData?.is_daily_reward_achieved
export const gettingSignupReward = (state) => state?.AuthReducer?.userData?.is_signup_bonus_achieved
export const UpdatedData  = (state) => state?.ProfileReducer?.getuserData
export const isProfileCompleted   = (state) => state?.ProfileReducer?.getuserData?.isProfileComplete
export const LessonId   = (state) =>  state?.otpVerificationReducer?.LessonId
export const AvatarList = (state) =>state?.ProfileReducer?.getavatarData
export const RakutenCoupenLists = (state) => state?.RakutenReducer.getRakutenData


